import { put, putResolve, select, takeEvery } from 'redux-saga/effects';
import { all, call } from 'redux-saga/effects';
import * as actions from '../../actions/accounting-actions';
import { fetch } from '../../actions/utility-actions';
import { CreditCategory } from '../../models/accounting/credit/credit-category';
import { CreditReason } from '../../models/accounting/credit/credit-reason';
import { CachedStoreObject } from '../../models/utilities/cached-store-object';
import { getCachedCreditCategories, getCachedCreditReasons } from '../../selectors/accounting-selectors';
import { ApiEndpoints } from '../../utils/app-constants';
import { AppUtils } from '../../utils/app-utils';
import { Mapper } from '../../utils/mapper';

/**
 * Saga to update the cahced credit categories
 */
export function* fetchCreditCategories() : any {

    const cachedCategories = yield (select(getCachedCreditCategories));
    const cachedReasons = yield (select(getCachedCreditReasons));
    
    if (!AppUtils.isCacheExpired(cachedCategories) && !AppUtils.isCacheExpired(cachedReasons)) {
        console.log("Cached Credit Categories and Reasons are OK");
    }
    else {

        const [rawReasons,
            rawCategories] = yield all([
                putResolve(fetch(ApiEndpoints.ACCOUNTING_CREDIT_REASONS, 'GET')),
                putResolve(fetch(ApiEndpoints.ACCOUNTING_CREDIT_CATEGORIES, 'GET'))
            ]);

        const [reasons,
            categories] = yield all([
                call(parseReasonsReponse, rawReasons),
                call(parseCategoriesReponse, rawCategories)
            ])
        
        const r = new CachedStoreObject(reasons, 60);
        const c = new CachedStoreObject(categories, 60);

        yield put(actions.fetchCreditReasonsSuccess(r));
        yield put(actions.fetchCreditCategoriesSuccess(c));
    }
}

/**
 * Parse the raw reasons
 * @param data The list of reasons to parse
 */
const parseReasonsReponse = (data: any) => {

    if (!AppUtils.IsEmpty(data)) {

        const tmpReasons: CreditReason[] = [];

        data.forEach((item: any) => {
            const tmpReason = Mapper.deserialize(CreditReason, item);
            if (tmpReason) {
                tmpReasons.push(tmpReason);
            }
        });

        data = tmpReasons;
    }

    return data;
};

/**
 * Parse the raw reasons
 * @param data The list of reasons to parse
 */
const parseCategoriesReponse = (data: any) => {

    if (!AppUtils.IsEmpty(data)) {

        const tmpCategories: CreditCategory[] = [];

        data.forEach((item: any) => {
            const tmpCategory = Mapper.deserialize(CreditCategory, item);
            if (tmpCategory) {
                tmpCategories.push(tmpCategory);
            }
        });

        data = tmpCategories;
    }

    return data;
};

/**
 * Watch for the credit category request
 */
export function* watchGetCreditCategories() {
    yield takeEvery(actions.ACCOUNTING_CREDIT_PAGEDATA_FETCH, fetchCreditCategories);
}
